import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import styles from "./button.module.css";
import colors from '../../styles/color.module.css';

export default function Button({ href, icon, onClick, text, isDisabled, isRevert, type = 'purple', large }) {
  const ContainerComponent = href ? Link : 'a';

  return (
    <ContainerComponent
      className={cn(styles.container, colors[type], {
        [styles.disabled]: isDisabled,
        [styles.large]: large,
        [styles.revert]: isRevert
      })}
      to={href}
      onClick={onClick}
    >
      {icon && <img width="18px" height="18px" src={icon} alt="Icon" />}
      <span>{text}</span>
    </ContainerComponent>
  );
}
